import React, { useContext, createContext } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const bootstrap = getBootstrap();

const touchPointDataProviderContext = {
    theme: {
        logos: bootstrap.get('logos', {}),
        activeFonts: bootstrap.get('activeFonts', []),
        colors: bootstrap.get('colors', []),
    },
    event: {
        id: bootstrap.get('event.id'),
        title: bootstrap.get('event.title'),
        confirmationsConfig: {
            headline: '',
            messaging: '',
            tickets: null,
        },
        multisession: bootstrap.get('splashPage.multisession', 0),
        touchpoint: '',
    },
    embeds: {},
    guest: {
        guestAccessHash: null,
    },
};

const TouchPointDataProviderContext = createContext(touchPointDataProviderContext);

export const TouchpointDataProvider = ({ children, event, theme, context, embeds, guest }) => {
    const mergedContext = merge(context, { event, theme, embeds, guest });

    return (
        <TouchPointDataProviderContext.Provider value={mergedContext}>
            {children}
        </TouchPointDataProviderContext.Provider>
    );
};

TouchpointDataProvider.propTypes = {
    children: PropTypes.node,
    context: PropTypes.object,
    event: PropTypes.object,
    theme: PropTypes.object,
    embeds: PropTypes.object,
    guest: PropTypes.object,
};

TouchpointDataProvider.defaultProps = {
    children: null,
    context: touchPointDataProviderContext,
    event: {},
    theme: {},
    embeds: {},
    guest: {},
};

export const useTouchpointData = () => useContext(TouchPointDataProviderContext);
